module.exports = __webpack_public_path__ + "img/form-img1.e0ba350d.png";